import PouchDB from "pouchdb";
import plugin from "pouchdb-find";
import Vue from "vue";
import Vuex from "vuex";
import { tripStore } from "./stores/trip";
import { placeStore } from "./stores/place";
import { expenseStore } from "./stores/expense";
import { authStore } from "./stores/auth";
import { syncStore } from "./stores/sync";
import { statStore } from "./stores/stat";
import { carStore } from "./stores/car";

Vue.use(Vuex);

PouchDB.plugin(plugin);

export const store = new Vuex.Store({
  modules: {
    trip: tripStore,
    place: placeStore,
    expense: expenseStore,
    auth: authStore,
    stat: statStore,
    sync: syncStore,
    car: carStore
  },
  state: {
    database: new PouchDB(
      "userLocalDB4", //Do Not change this name
      { deterministic_revs: true }
    ),
    allRecords: "",
    isSuccess: [],
    isError: [],
    // autoPoplulate: "",
    lastRecord: "",
    doNotShowAlert: ["last_synced_time"],
    isLoading: false
  },
  getters: {
    getIsSucces: state => {
      return state.isSuccess[0];
    },
    getIsError: state => {
      return state.isError[0];
    },
    allRecords: () => {
      return [
        ...store.state.place.all,
        ...store.state.trip.all,
        ...store.state.car.allCars,
        ...store.state.expense.all
      ];
    }
  },
  mutations: {
    initApp() {
      //fire the is loggedin
      store.dispatch("auth/checkAuthAction");
      store.dispatch("car/getAllCarsAction");
      setTimeout(function() {
        console.log(store.getters["car/getDefaultCar"]);
        store.getters["car/getDefaultCar"] ||
          store.commit("car/defaultVehicle");
        store.commit("place/getAllPlaces");
        // store.getters["place/getDefaultPlacesList"].length > 0 ||
        //   store.commit("place/saveDefaultPlace");
        store.commit("sync/getLastSyncedTime");

        //get starting year
        store.commit("stat/getStartDate");
      }, 2000);
    },

    //    query records
    getAllRecord() {
      store.commit("place/getAllPlaces");
      store.commit("trip/getAllTrips");
      store.commit("expense/getAllExpenses");
      store.commit("car/getCars");
    },

    getRecordByType(state, types) {
      state.database
        .find({
          selector: { type: { $in: types }, _id: { $exists: true } },
          sort: ["_id"]
        })
        .then(result => {
          state.allRecords = result.docs.reverse();
        })
        .catch(function(err) {
          console.log(err);
        });
    },

    //save records
    saveR(state, formData) {
      state.database.put(formData, function callback(err) {
        if (err) {
          store.dispatch("SetStatusMessageAction", {
            mutator: "fail",
            value: "failSave"
          });
          return false;
        }
        if (state.doNotShowAlert.indexOf(formData.type) === -1) {
          store.dispatch("SetStatusMessageAction", {
            mutator: "success",
            value: "successSave",
            is_default: formData.is_default
          });
        }
        store.dispatch("getRecords", [formData.type]);
        store.commit("sync/getUnsyncedRecords");
      });
    },

    //set isSuccess state to true
    success(state, type) {
      //only for none default values
      if (!type.is_default) {
        state.isSuccess.push(type.value);
      }
    },

    //set isError state to true
    fail(state, type) {
      state.isError.push(type);
    },

    clearMes(state) {
      setTimeout(() => {
        state.isSuccess = [];
        state.isError = [];
      }, 2000);
      return true;
    },

    //set record for deletion
    setRecordForDeletion(state, doc) {
      store.commit("saveR", doc);
    },

    //delete record from Pouch
    deleteRecord(state, id) {
      state.database
        .get(id)
        .then(function(doc) {
          state.database.remove(doc._id, doc._rev).then(res => {
            console.log(res);
          });
          store.dispatch("SetStatusMessageAction", {
            mutator: "success",
            value: "successDelete"
          });
        })
        .catch(function(err) {
          store.dispatch("SetStatusMessageAction", {
            mutator: "fail",
            value: "failDelete"
          });
          console.log(err);
        });
    },

    saveDefaultsIfNotPresent() {
      store.commit("car/defaultVehicle"); //default car
      store.commit("place/saveDefaultPlace", store.state.place.defaultPlace); //default place
      store.commit("car/getDefaultCars", store.state.place.defaultPlace); //default place
      console.log(store.state.place.defaultPlace);
    },

    loading(state, isLoading) {
      if (isLoading) {
        state.isLoading = true;
      } else {
        state.isLoading = false;
      }
    }
  },
  actions: {
    getRecords({ commit }, types) {
      commit("getRecordByType", types);
    },
    saveRecords(context, formData) {
      context.commit("saveR", formData);
      // context.dispatch("getRecords", [formData.type])
    },
    deleteRecordAction(context, id) {
      context.commit("deleteRecord", id);
    },
    setRecordForDeletionAction(context, doc) {
      context.commit("setRecordForDeletion", doc);
    },
    // getLastRecordAction(context, type){
    //     context.commit("getLastRecordByType", type);
    // },
    SetStatusMessageAction(context, data) {
      if (!data.is_default) {
        context.commit(data.mutator, {
          value: data.value,
          is_default: data.is_default
        });
      }
      context.commit("clearMes");
    }
  }
});
